import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

// Initialises Laravel Echo against the backend's Reverb server (Pusher
// protocol). Only needed for the order-picking presence lock, so it stays a
// no-op when the user isn't logged in or no Reverb app key is configured.
export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return

  const userStore = useUserStore()
  if (!userStore.isLoggedIn) return

  const { apiBaseUrl, echo } = useAppConfig() as unknown as {
    apiBaseUrl: string
    echo?: { host: string; appKey: string; port?: number; scheme?: string }
  }

  if (!echo?.appKey) {
    // Presence lock disabled until app.config `echo.appKey` is set to the
    // backend's Reverb app key. Fail soft rather than crashing the app.
    console.warn('[echo] appKey missing — order-picking presence lock disabled')
    return
  }

  // Config mirrors the proven 1tool-suite-nuxt Echo setup: the channel authorizes
  // via the tenant encoded in the channel name (proposal.{tenant}.{id}), so the
  // bearer token alone is enough for broadcasting/auth — no X-Tenant header.
  ;(window as unknown as { Pusher: typeof Pusher }).Pusher = Pusher
  ;(window as unknown as { Echo: Echo<'pusher'> }).Echo = new Echo<'pusher'>({
    broadcaster: 'pusher',
    key: echo.appKey,
    cluster: 'eu',
    wsHost: echo.host,
    wsPort: echo.port ?? 443,
    wssPort: echo.port ?? 443,
    forceTLS: (echo.scheme ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
    // broadcasting/auth is registered by Broadcast::routes() at the app root, NOT
    // inside the `api/` route group — so strip the trailing `api/` from apiBaseUrl
    // (…/suite/api/ → …/suite/broadcasting/auth). POSTing to …/api/broadcasting/auth
    // hits the wrong route ("POST not supported, only GET/HEAD").
    authEndpoint: `${apiBaseUrl.replace(/api\/?$/, '')}broadcasting/auth`,
    bearerToken: userStore.user.api_token
  })
})
